import { initializeApp } from '@firebase/app';
import { browserSessionPersistence, initializeAuth } from '@firebase/auth';
import { getDatabase } from '@firebase/database';

const firebase = initializeApp({
	apiKey: process.env.PUBLIC_FIREBASE_API_KEY,
	authDomain: process.env.PUBLIC_FIREBASE_AUTH_DOMAIN,
	projectId: process.env.PUBLIC_FIREBASE_PROJECT_ID,
	measurementId: process.env.PUBLIC_FIREBASE_MEASUREMENT_ID,
	databaseURL: process.env.PUBLIC_FIREBASE_DATABASE_URL,
});

const auth = initializeAuth(firebase, { persistence: browserSessionPersistence });

const database = getDatabase(firebase);

export { firebase, auth, database };
